import { render, staticRenderFns } from "./CellSwitch.vue?vue&type=template&id=53f352c8"
import script from "./CellSwitch.vue?vue&type=script&lang=js"
export * from "./CellSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports